import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Popover,
  Tooltip,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

/**
 * "How this is calculated": what a report counts and the fields it reads,
 * each in the registry's own words, so a report never needs explaining
 * outside the app.
 */
export const HowCalculated = ({ definition, fields, onOpenDictionary }) => {
  const [anchor, setAnchor] = useState(null);
  const used = (definition.fieldsUsed ?? [])
    .map((key) => fields.find((f) => f.key === key))
    .filter(Boolean);
  if (!definition.explains && !used.length) return null;
  return (
    <>
      <Tooltip title="How this is calculated">
        <IconButton
          aria-label="How this is calculated"
          color="primary"
          onClick={(e) => setAnchor(e.currentTarget)}
        >
          <InfoOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: { sx: { width: 420, maxWidth: "calc(100vw - 32px)", p: 2 } },
        }}
      >
        <Typography
          variant="subtitle1"
          component="h2"
          sx={{ fontWeight: 500, mb: 1 }}
        >
          How this is calculated
        </Typography>
        {definition.explains && (
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            {definition.explains}
          </Typography>
        )}
        {used.length > 0 && (
          <Box component="dl" sx={{ m: 0 }}>
            {used.map((f) => (
              <Box key={f.key} sx={{ mb: 1 }}>
                <Typography
                  component="dt"
                  variant="body2"
                  sx={{ fontWeight: 500 }}
                >
                  {f.label}
                </Typography>
                <Typography
                  component="dd"
                  variant="body2"
                  color="text.secondary"
                  sx={{ m: 0 }}
                >
                  {f.description}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
        <Button
          size="small"
          onClick={() => {
            setAnchor(null);
            onOpenDictionary();
          }}
          sx={{ mt: 0.5, ml: -1 }}
        >
          Open the data dictionary
        </Button>
      </Popover>
    </>
  );
};
